<template>
  <qc-container title="编辑优惠券" show-divider show-return>
    <el-form class="mt20" ref="ruleForm"  :model="addRow"  label-width="100px">
      <form-item-rule label="名称" prop="name">
        <el-input v-model="addRow.name"></el-input>
      </form-item-rule>
      <form-item-rule label="门店类型" prop="storeType">
        <simple-btn v-model="addRow.storeType" :init-options="[{label:'实体店',value:'0'},{label:'洗消店',value:'1'}]"></simple-btn>
      </form-item-rule>
      <form-item-rule label="优惠券类型" prop="cardType">
        <simple-btn v-model="addRow.cardType" :init-options="cardTypeList"></simple-btn>
      </form-item-rule>
      <form-item-rule label="领券中心展示" prop="isIndex">
        <simple-btn v-model="addRow.isIndex" :init-options="[{label:'否',value:'0'},{label:'是',value:'1'}]"></simple-btn>
      </form-item-rule>
      <form-item-rule class="row" label="发放数量" prop="count">
        <el-input-number class="w200"   :controls="false"  v-model="addRow.count"  placeholder="请输入发放数量"  ></el-input-number>
        <span class="ml10">份</span>
      </form-item-rule>
      <form-item-rule class="row" label="优惠金额" prop="cardType">
        <template v-if="addRow.cardType==0">
          <span class="mr10">订单满</span>
          <el-input-number class="w200"   :controls="false" v-model="addRow.fullMoney"  placeholder="请输入金额"  ></el-input-number>
          <span class="ml10 mr10">元,立减</span>
          <el-input-number class="w200"   :controls="false"  v-model="addRow.money"  placeholder="请输入金额"  ></el-input-number>
          <span class="ml10">元</span>
        </template>
        <template v-else-if="addRow.cardType==2">
          <span class="mr10">租赁满</span>
          <el-input-number class="w200"   :controls="false" v-model="addRow.fullMoney"  placeholder="请输入天数"  ></el-input-number>
          <span class="ml10 mr10">天,立减</span>
          <el-input-number class="w200"   :controls="false"  v-model="addRow.money"  placeholder="请输入天数"  ></el-input-number>
          <span class="ml10">天</span>
        </template>
        <template v-else="">
          <span class="mr10">订单满</span>
          <el-input-number class="w200"   :controls="false" v-model="addRow.fullMoney"  placeholder="请输入金额"  ></el-input-number>
          <span class="ml10 mr10">元,打</span>
          <el-input-number class="w200"  :min="0.0" :precision="1" :max="10"  :controls="false"  v-model="addRow.money"  placeholder="请输入折扣"  ></el-input-number>
          <span class="ml10">折</span>
        </template>
      </form-item-rule>
      <form-item-rule class="row" label="有效期" prop="timeType">
        <span class="mr10">领取后</span>
        <el-input-number class="w200" :disabled="addRow.timeType===2" :controls="false" v-model="addRow.dayTime"  placeholder="请输入天数"  ></el-input-number>
        <span class="ml10">天内，不使用自动过期</span>
        <el-checkbox class="ml20" v-model="addRow.timeType" :true-label="2" :false-label="1">长期有效</el-checkbox>
      </form-item-rule>
      <form-item-rule class="row" label="活动时间" >
        <div class="w400">
          <date-picker @change="changeTime" :disabled="addRow.actTimeType===1" :start-date="addRow.startTime" :end-date="addRow.endTime"></date-picker>
        </div>
        <el-checkbox class="ml20" v-model="addRow.actTimeType" :true-label="1" :false-label="0">长期有效</el-checkbox>
      </form-item-rule>
      <form-item-rule class="row" label="活动对象" prop="goodsType">
        <simple-btn v-model="addRow.goodsType" :init-options="[{label:'全部商品',value:'0'},{label:'指定门店',value:'2'},{label:'指定商品',value:'1'}]"></simple-btn>
      </form-item-rule>
      <el-form-item v-if="addRow.goodsType==1" class="row" label="参与商品">
        <goods-select ref="goodsSelect" @change="goodsChange"></goods-select>
      </el-form-item>
      <el-form-item v-if="addRow.goodsType==2" class="row" label="参与门店">
        <shop-select ref="shopSelect" @change="goodsChange"></shop-select>
      </el-form-item>
      <el-form-item class="tc">
        <el-button @click="returnLast()">取消</el-button>
        <el-button type="primary" @click="doSave()">确定</el-button>
      </el-form-item>
    </el-form>
  </qc-container>
</template>

<script>
import FormItemRule from "/src/components/el/form-item-rule";
import SimpleDict from "/src/components/dict/SimpleDict";
import QcContainer from "@/components/el/layout/qc-container.vue";
import SimpleBtn from "@/components/base/simple-btn.vue";
import DatePicker from "@/components/base/DatePicker.vue";
import GoodsSelect from "@view/components/goods/goods-select.vue";
import ShopSelect from "@view/components/shop/shop-select.vue";
export default {
  name: "coupon-add",
  components: {ShopSelect, GoodsSelect, DatePicker, SimpleBtn, QcContainer, FormItemRule,SimpleDict},
  data() {
    return {
      visible: false,
      addRow: {name:"",storeType:"0",cardType:"0",isIndex:"0",count:"",money:"",fullMoney:"",startTime:"",endTime:"",goodsType:0,dayTime:"",actTimeType:0,timeType:1,type:0,refGoodsList:[]},
    }
  },
  computed:{
    cardTypeList(){
      if(this.addRow.storeType=="0"){
        return [{label:'满减',value:'0'},{label:'折扣',value:'1'},{label:'租赁',value:'2'}];
      }
      return [{label:'满减',value:'0'},{label:'折扣',value:'1'}];
    }
  },
  mixins: [tableBase],
  methods: {
    changeTime(dateArr){
      this.addRow.startTime = dateArr&&dateArr[0] || "";
      this.addRow.endTime = dateArr&&dateArr[1] || "";
    },
    goodsChange(goodsList){
      this.addRow.refGoodsList = [];
      goodsList.forEach((row)=>{
        if(this.addRow.refGoodsList.indexOf(row.id)<0){
          this.addRow.refGoodsList.push({goodsId:row.id,type:1});
        }
      })
    },
    doSave(){
      this.$refs['ruleForm'].validate((valid) => {
        if (valid) {
          if(this.addRow.count<=0){
            this.messageError("发放数量必须大于0");
            return;
          }
          if(this.addRow.fullMoney<=0 || this.addRow.money<=0){
            this.messageError("优惠金额必须大于0");
            return;
          }
          if(this.addRow.actTimeType==0){
            if(!(this.addRow.startTime&&this.addRow.endTime)){
              this.messageError("活动时间不能为空");
              return;
            }
          }
          if(this.addRow.timeType==0){
            if(!(this.addRow.dayTime)){
              this.messageError("有效期不能为空");
              return;
            }
            if(this.addRow.dayTime<=0){
              this.messageError("有效期必须大于0");
              return;
            }
          }
          this.simplePost("/api/mgr/business/card/discount/addOrUpdate", {contentType:_CONTENT_TYPE_JSON,...this.addRow}, () => {
            this.returnLast();
          })
        }
      })
    }
  },
  mounted() {
    if(this.$route.query.id){
      this.simpleGet("/api/mgr/business/card/discount/detail",{id:this.$route.query.id},(res)=>{
        this.addRow = res.data;
        if(this.addRow.goodsType===1){
          this.$nextTick(()=>{
            this.$refs.goodsSelect.setTableData(this.addRow.refGoodsList);
          })
        }else if(this.addRow.goodsType===2){
          this.$nextTick(()=>{
            this.$refs.shopSelect.setTableData(this.addRow.refGoodsList);
          })
        }
      })
    }
  }
}
</script>

<style lang="less" scoped>

</style>
